module.exports = __webpack_public_path__ + "img/loans.5d13810.png";